import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import buildRoute from 'components/buildRoute';
import PageHeader from 'components/PageHeader';
import UserAdministration from './components/UserAdministration';
import DropdownManagement from './components/DropdownManagement';
import DataRestrictionsManagement from './components/DataRestrictionsManagement';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export const HartAdminPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [currentTab, setCurrentTab] = useState(tabParam ? parseInt(tabParam, 10) : 0);

  // Update tab when URL parameter changes
  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      const tabIndex = parseInt(tabParam, 10);
      if (tabIndex >= 0 && tabIndex <= 2) {
        setCurrentTab(tabIndex);
      }
    }
  }, [searchParams]);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    setSearchParams({ tab: newValue });
  };

  return (
    <>
      <PageHeader
        title="Hart Admin Panel"
        subtitle="Manage users, dropdown fields, and data access restrictions"
      />

      <Paper sx={{ width: '100%', mt: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="admin panel tabs"
          >
            <Tab icon={<PeopleOutlineIcon />} iconPosition="start" label="Users" id="admin-tab-0" aria-controls="admin-tabpanel-0" />
            <Tab icon={<ListAltIcon />} iconPosition="start" label="Dropdown Fields" id="admin-tab-1" aria-controls="admin-tabpanel-1" />
            <Tab icon={<LockOutlinedIcon />} iconPosition="start" label="Data Restrictions" id="admin-tab-2" aria-controls="admin-tabpanel-2" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <UserAdministration />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <DropdownManagement />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <DataRestrictionsManagement />
        </TabPanel>
      </Paper>
    </>
  );
};

const routeArgs = {
  element: <HartAdminPage />,
};

export default buildRoute(routeArgs);
